import { fetchError, fetchStart, fetchSuccess } from "../../../redux/actions";
import {
  setAuthUser,
  setForgetPassMailSent,
  updateLoadUser,
  setToken,
} from "../../../redux/actions/Auth";
import { setCurrentUser } from "../../../redux/actions/Users";
import React from "react";
import axios from "../jwt/config";

const BasicAuth = {
  onRegister: ({ name, email, password }) => {
    return (dispatch) => {
      dispatch(fetchStart());

      setTimeout(() => {
        dispatch(fetchSuccess());
        const user = { name: name, email: email, password: password };
        localStorage.setItem("user", JSON.stringify(user));
        dispatch(setAuthUser(user));
      }, 300);
    };
  },

  onLogin: ({ personalCode, password,otp, shouldRemember }) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post("/user/adminlogin", {
            nationalCode: personalCode,
            password: password,
            otp: otp,
          })
          .then(({ data }) => {
            const { admin, token } = data;
            dispatch(fetchSuccess("با موفقیت وارد شدید!!!"));
            if (shouldRemember) {
              localStorage.setItem("Token", token);
            } else {
              sessionStorage.setItem("Token", token);
            }
            dispatch(setToken(token));
            dispatch(setAuthUser(admin.id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  onLogout: () => {
    return (dispatch) => {
      dispatch(fetchStart());

      setTimeout(() => {
        dispatch(fetchSuccess());
        // localStorage.removeItem('user');
        localStorage.removeItem("Token");
        sessionStorage.removeItem("Token");
        delete axios.defaults.headers.common["Authorization"];
        dispatch(setAuthUser(null));
        dispatch(setToken(null));
      }, 300);
    };
  },

  getAuthUser: (loaded = false) => {
    return (dispatch) => {
      dispatch(fetchStart());
      dispatch(updateLoadUser(loaded));

      setTimeout(() => {
        dispatch(fetchSuccess());
        dispatch(setAuthUser(JSON.parse(localStorage.getItem("user"))));
      }, 300);
    };
  },

  onForgotPassword: () => {
    return (dispatch) => {
      dispatch(fetchStart());

      setTimeout(() => {
        dispatch(setForgetPassMailSent(true));
        dispatch(fetchSuccess());
      }, 300);
    };
  },

  getMe: () => {
    return (dispatch) => {
      try {
        axios
          .get("/user/getme")
          .then(({ data }) => {
            dispatch(setCurrentUser(data.user));
          })
          .catch((error) => {
            dispatch(BasicAuth.onLogout());
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(BasicAuth.onLogout());
        dispatch(fetchError(error.message));
      }
    };
  },

  getSocialMediaIcons: () => {
    return <React.Fragment> </React.Fragment>;
  },
};

export default BasicAuth;
